export const buildings=[
 {
  "id": "temple",
  "x": -15,
  "z": -42,
  "rotation": 0,
  "lodDistance": 60,
  "model": "elmir_temple_01",
  "boxes": [
   {
    "center": [
     1.375,
     5.0,
     -0.62
    ],
    "size": [
     12.3,
     10,
     21.3
    ]
   },
   {
    "center": [
     -5.225,
     10.0,
     6.18
    ],
    "size": [
     5.3,
     20,
     5.5
    ]
   },
   {
    "center": [
     1.375,
     0.4,
     11.0
    ],
    "size": [
     4,
     0.8,
     1.7
    ]
   },
   {
    "center": [
     -4.975,
     2.2,
     -9.22
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   },
   {
    "center": [
     -4.975,
     2.2,
     -3.22
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   },
   {
    "center": [
     -4.975,
     2.2,
     2.78
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   },
   {
    "center": [
     7.725,
     2.2,
     -9.22
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   },
   {
    "center": [
     7.725,
     2.2,
     -3.22
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   },
   {
    "center": [
     7.725,
     2.2,
     2.78
    ],
    "size": [
     0.8,
     4.4,
     0.7
    ]
   }
  ],
  "parts": [],
  "entry": [
   1.375,
   0.0,
   11.38
  ],
  "approach": [
   1.375,
   0.0,
   13.18
  ]
 },
 {
  "id": "shop",
  "x": 20,
  "z": -27,
  "rotation": 0,
  "lodDistance": 35,
  "model": "elmir_shop_01",
  "boxes": [
   {
    "center": [
     -1.8025,
     3.0,
     -0.3
    ],
    "size": [
     7.2,
     6,
     10.1
    ]
   },
   {
    "center": [
     3.5975,
     1.0,
     3.5
    ],
    "size": [
     2.95,
     1.7,
     0.95
    ]
   },
   {
    "center": [
     1.7975,
     1.575,
     -1.85
    ],
    "size": [
     0.38,
     3.15,
     0.38
    ]
   },
   {
    "center": [
     1.7975,
     1.575,
     4.65
    ],
    "size": [
     0.38,
     3.15,
     0.38
    ]
   },
   {
    "center": [
     5.3975,
     1.575,
     -1.85
    ],
    "size": [
     0.38,
     3.15,
     0.38
    ]
   },
   {
    "center": [
     5.3975,
     1.575,
     4.65
    ],
    "size": [
     0.38,
     3.15,
     0.38
    ]
   },
   {
    "center": [
     3.262500006556511,
     0.574999988079071,
     -0.7
    ],
    "size": [
     1.629999965429306,
     1.149999976158142,
     0.9800000190734863
    ]
   },
   {
    "center": [
     -3.0025,
     0.12,
     5.25
    ],
    "size": [
     1.9,
     0.24,
     0.9
    ]
   }
  ],
  "parts": [
   {
    "file": "elmir_shop_decor_01.glb",
    "position": [
     3.5975,
     0.0,
     -0.7
    ],
    "rotation_y": 0
   }
  ],
  "entry": [
   -3.0025,
   0.0,
   5.4
  ],
  "approach": [
   3.5975,
   0.0,
   2.0
  ]
 },
 {
  "id": "blacksmith",
  "x": -26,
  "z": 18,
  "rotation": 3.141592653589793,
  "lodDistance": 40,
  "model": "elmir_blacksmith_01",
  "boxes": [
   {
    "center": [
     -2.185,
     4.0,
     0.0
    ],
    "size": [
     8.4,
     8,
     12.7
    ]
   },
   {
    "center": [
     4.615,
     1.0,
     -1.9
    ],
    "size": [
     2.5,
     1.2,
     0.85
    ]
   },
   {
    "center": [
     1.915,
     1.75,
     -3.8
    ],
    "size": [
     0.38,
     3.5,
     0.38
    ]
   },
   {
    "center": [
     1.915,
     1.75,
     5.2
    ],
    "size": [
     0.38,
     3.5,
     0.38
    ]
   },
   {
    "center": [
     6.515,
     1.75,
     -3.8
    ],
    "size": [
     0.38,
     3.5,
     0.38
    ]
   },
   {
    "center": [
     6.515,
     1.75,
     5.2
    ],
    "size": [
     0.38,
     3.5,
     0.38
    ]
   },
   {
    "center": [
     4.215,
     1.287500023841858,
     -3.0
    ],
    "size": [
     2.0999999046325684,
     2.575000047683716,
     1.7000000476837158
    ]
   },
   {
    "center": [
     4.462500002384186,
     0.6474999785423279,
     1.1
    ],
    "size": [
     1.5449999570846558,
     1.2949999570846558,
     0.75
    ]
   }
  ],
  "parts": [
   {
    "file": "elmir_forge_furnace_01.glb",
    "position": [
     4.215,
     0.0,
     -3.0
    ],
    "rotation_y": 0
   },
   {
    "file": "elmir_forge_anvil_01.glb",
    "position": [
     4.215,
     0.0,
     1.1
    ],
    "rotation_y": 0
   }
  ],
  "entry": [
   -3.885,
   0.0,
   7.0
  ],
  "approach": [
   4.315,
   0.0,
   2.8
  ]
 }
] as const;
export function localPoint(b:{x:number;z:number;rotation:number},p:readonly number[]){const c=Math.cos(b.rotation),s=Math.sin(b.rotation);return {x:b.x-c*p[0]+s*p[2],z:b.z+s*p[0]+c*p[2]};}

// Fixed grid: [-500,500), 20 x 20 cells, X/Z indexes 0..19.
export const CONFIG={size:1000,chunk:50,radius:2,retention:3,parallel:2,budgetMs:4,treeRadius:1,seed:73421};
export const lots=Array.from({length:0},(_,i)=>({x:(i%2?1:-1)*45,z:-75+Math.floor(i/2)*35}));
export function cell(x:number,z:number){return {x:Math.max(0,Math.min(19,Math.floor((x+500)/50))),z:Math.max(0,Math.min(19,Math.floor((z+500)/50)))};}
export function hash(x:number,z:number){let n=Math.imul(x+CONFIG.seed,374761393)^Math.imul(z,668265263);n=Math.imul(n^(n>>>13),1274126177);return ((n^(n>>>16))>>>0)/4294967296;}
function sample(x:number,z:number){const blend=Math.min(1,Math.max(0,(Math.max(Math.abs(x),Math.abs(z))-100)/80));return blend*blend*(8*Math.sin(x/95)*Math.cos(z/110)+4*Math.sin((x+z)/55));}
// Triangle interpolation matches terrain vertices exactly (10m grid).
export function height(x:number,z:number){
 const gx=Math.floor(x/10)*10,gz=Math.floor(z/10)*10,u=(x-gx)/10,v=(z-gz)/10;
 const a=sample(gx,gz),b=sample(gx+10,gz),c=sample(gx,gz+10),d=sample(gx+10,gz+10);
 return u+v<=1?a+(b-a)*u+(c-a)*v:d+(c-d)*(1-u)+(b-d)*(1-v);
}
const treeCache=new Map<string,{x:number;z:number}[]>();
export function treePositions(cx:number,cz:number){
 const key=cx+','+cz;if(treeCache.has(key))return treeCache.get(key)!;
 const out:{x:number;z:number}[]=[];
 for(let i=0;i<5;i++){const x=-500+cx*50+5+hash(cx*17+i,cz*3)*40,z=-500+cz*50+5+hash(cx*5,cz*19+i)*40;
 if(Math.max(Math.abs(x),Math.abs(z))<110||Math.abs(x)<9||Math.abs(z)<9||hash(cx,cz)<.24)continue;
 out.push({x,z});}treeCache.set(key,out);return out;
}
export type Obstacle={x:number;z:number;height:number}&({kind:'circle';radius:number}|{kind:'box';halfX:number;halfZ:number});
export const obstacles:Obstacle[]=[{kind:'circle',x:0,z:0,height:6.15,radius:2.15},{kind:'box',x:14,z:8,height:8.825,halfX:4.5,halfZ:5.3},{kind:'box',x:11.45,z:14,height:.55,halfX:1.25,halfZ:.8}];
for(const b of buildings)for(const box of b.boxes){const p=localPoint(b,box.center);obstacles.push({kind:'box',...p,height:box.size[1],halfX:box.size[0]/2,halfZ:box.size[2]/2});}
export function nearby(x:number,z:number):Obstacle[]{
 const c=cell(x,z),out=[...obstacles];
 for(let i=Math.max(0,c.x-1);i<=Math.min(19,c.x+1);i++)for(let j=Math.max(0,c.z-1);j<=Math.min(19,c.z+1);j++)
 out.push(...treePositions(i,j).map(t=>({...t,height:8,kind:'circle' as const,radius:.8})));
 return out;
}
export function blocked(x:number,z:number){
 if(Math.abs(x)>499.6||Math.abs(z)>499.6)return true;
 return nearby(x,z).some(o=>o.kind==='circle'?Math.hypot(x-o.x,z-o.z)<o.radius+.35:Math.hypot(Math.max(0,Math.abs(x-o.x)-o.halfX),Math.max(0,Math.abs(z-o.z)-o.halfZ))<.35);
}
export function move(x:number,z:number,dx:number,dz:number){const n=Math.max(1,Math.ceil(Math.hypot(dx,dz)/.12));for(let i=0;i<n;i++){if(!blocked(x+dx/n,z))x+=dx/n;if(!blocked(x,z+dz/n))z+=dz/n;}return {x,z};}
